import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import axios from 'axios'
import {host} from '../../function/api'

const initialState = {
    ruleList: [],
    permission: [],
    loading: false,
    status: false,
    success: false,
    message: '',
    error: '',
    errorProfile: '',
    errorPermission: ''
}
export const permissionStore = createAsyncThunk(
    'permission/store',
    async(data, thunkApi) => {
        try {
            const response = await axios({
                method: 'POST',
                url: `${host}permission`,
                data: data,
                headers: {
                    'Accept': 'Application/json',
                    'xsrfHeaderName': "X-XSRF-TOKEN",
                    'Access-Control-Allow-Origin': "*",
                    'withCredentials': true,
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            })

            return await response.data

        } catch(error) {
            return thunkApi.rejectWithValue(error)
        }
    }
)
export const permissionList = createAsyncThunk(
    'permission/list',
    async(thunkApi) => {
        try {
            const response = await axios({
                method: 'GET',
                url: `${host}permission`,
                // data: data,
                headers: {
                    'Accept': 'Application/json',
                    'xsrfHeaderName': "X-XSRF-TOKEN",
                    'withCredentials': true,
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            })

            return await response.data

        } catch(error) {
            return thunkApi.rejectWithValue(error)
        }
    }
) 
export const fetchRules = createAsyncThunk(
    'rule/list',
    async(data,thunkApi) => {
        try {
            const response = await axios({
                method: 'POST',
                url: `${host}rule/user`,
                data: data,
                headers: {
                    'Accept': 'Application/json',
                    'xsrfHeaderName': "X-XSRF-TOKEN",
                    'withCredentials': true,
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            })

            return await response.data

        } catch(error) {
            return thunkApi.rejectWithValue(error)
        }
    }
) 
const permissionSlice = createSlice({
    name: 'permission',
    initialState,
    reducers:{

    },
    extraReducers:{
        [permissionStore.fulfilled]: (state, {payload}) => {  
            state.loading = false
            state.success = true
            state.message = payload.message
        },
        [permissionStore.pending] : (state) => {
            state.loading = true    
            state.success = false
        },
        [permissionStore.rejected]: (state, {payload}) => {
            state.loading = false
            state.success = false
            // if(payload.response.data.error) {
            //     state.errorTitle = payload.response.data.error.title
            //     state.errorArchives = payload.response.data.error.store_id
            // }else if(payload.response.data.message) {
            //     state.message = payload.response.data.message
            // }
            
        },
        [permissionList.fulfilled]: (state, action) => {
            state.loading = false
            state.success = true
            state.status = action.payload.status
            state.permissions = action.payload.data
        },
        [permissionList.pending]: (state) => {
            state.loading = true
            state.success = false
        },
        [permissionList.rejected]: (state, {payload}) => {
            state.loading = false;
            state.success = false
            state.status = payload.status
            if(payload.response.data.error){
                state.errorProfile = payload.response.data.errorProfile
                state.errorPermission = payload.response.data.permission
            } else if (payload.response.data.message) {
                state.message = payload.response.data.message
            }
        },
        [fetchRules.fulfilled]: (state, action) => {
            state.loading = false
            state.success = true
            state.status = action.payload.status
            state.ruleList = action.payload.data
        },
        [fetchRules.pending]: (state) => {
            state.loading = true
            state.success = false
            state.ruleList = []
        },
        [fetchRules.rejected]: (state, {payload}) => {
            state.loading = false;
            state.success = false
            state.status = payload.status
            if(payload.response.data.error){
                state.errorProfile = payload.response.data.errorProfile
                state.errorPermission = payload.response.data.permission
            } else if (payload.response.data.message) {
                state.message = payload.response.data.message
            }
        }
    }
})

export const {} = permissionSlice.actions;
export default permissionSlice.reducer;